import * as Sentry from "@sentry/react";
import { useAuthStore } from "../store/authStore";

// Initialize Sentry as early as possible. No-op if no DSN configured.
export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) {
    console.log("Sentry DSN not set, skipping init");
    return;
  }

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_APP_VERSION || undefined,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  });

  // Keep Sentry user in sync with the auth store
  const syncUser = (state) => {
    if (state.user?.id) {
      Sentry.setUser({
        id: String(state.user.id),
        username: state.user.name || state.user.email,
      });
      Sentry.setTag("product_id", state.selectedProductId || "none");
    } else {
      Sentry.setUser(null);
    }
  };
  syncUser(useAuthStore.getState());
  useAuthStore.subscribe(syncUser);
}

export { Sentry };
